import { ModalStates } from '@components'

import { EditManualBankAccountFormBody } from '@features/bankAccounts/elements/EditManualBankAccountModal/elements/EditManualBankAccountFormBody'
import { EditManualBankAccountFormFooter } from '@features/bankAccounts/elements/EditManualBankAccountModal/elements/EditManualBankAccountFormFooter'
import type { EditManualBankAccountFormApi } from '@features/bankAccounts/elements/EditManualBankAccountModal/hooks/useEditManualBankAccountForm'
import { Invoice } from '@features/invoicesLegacy/types/invoice'
import { BankLinesModalBody } from '@features/paymentReconciliationModal/elements/BankLinesModalBody'
import { BankLinesModalFooter } from '@features/paymentReconciliationModal/elements/BankLinesModalFooter'
import { ManualPaymentModalBody } from '@features/paymentReconciliationModal/elements/ManualPaymentModalBody'
import { ManualPaymentModalFooter } from '@features/paymentReconciliationModal/elements/ManualPaymentModalFooter'
import { MatchModalBody } from '@features/paymentReconciliationModal/elements/MatchModalBody'
import { InvoiceMatchModalFooter } from '@features/paymentReconciliationModal/elements/MatchModalFooter/InvoiceMatchModalFooter'
import { MultipleSubjectsModalFooter } from '@features/paymentReconciliationModal/elements/MultipleBillsModalFooter'
import { MultipleSubjectsModalBody } from '@features/paymentReconciliationModal/elements/MultipleSubjectsModalBody'
import { PrepaymentModalBody } from '@features/paymentReconciliationModal/elements/PrepaymentModalBody'
import { PrepaymentModalFooter } from '@features/paymentReconciliationModal/elements/PrepaymentModalFooter'
import { ReconciliationConnectBankBody } from '@features/paymentReconciliationModal/elements/ReconciliationConnectBankBody'
import { SubjectReconciliationModalStateId } from '@features/paymentReconciliationModal/enums/SubjectReconciliationModalStateId'
import { UiSource } from '@features/reconciliation/enums'

export const getInvoiceReconciliationModalStates = (
  csvAccountForm: EditManualBankAccountFormApi,
): ModalStates<SubjectReconciliationModalStateId> => [
  {
    id: SubjectReconciliationModalStateId.Match,
    headerTKey: 'bill.payment_reconcile.header.enter_payment_and_reconcile',
    modalBody: <MatchModalBody />,
    modalFooter: <InvoiceMatchModalFooter />,
  },
  {
    id: SubjectReconciliationModalStateId.BankLines,
    headerTKey: 'bill.payment_reconcile.header.enter_payment_and_reconcile',
    modalBody: <BankLinesModalBody />,
    modalFooter: <BankLinesModalFooter />,
    withBackwardsNavigation: true,
  },
  {
    backwardsNavigationStateId: SubjectReconciliationModalStateId.BankLines,
    id: SubjectReconciliationModalStateId.ManualPayment,
    headerTKey: 'bill.payment_reconcile.header.enter_payment',
    modalBody: <ManualPaymentModalBody />,
    modalFooter: <ManualPaymentModalFooter<Invoice> />,
    withBackwardsNavigation: true,
  },
  {
    id: SubjectReconciliationModalStateId.Prepayment,
    headerTKey: 'bill.payment_reconcile.header.use_prepayment',
    modalBody: <PrepaymentModalBody />,
    modalFooter: <PrepaymentModalFooter />,
    withBackwardsNavigation: true,
  },
  {
    backwardsNavigationStateId: SubjectReconciliationModalStateId.BankLines,
    id: SubjectReconciliationModalStateId.MultipleSubjects,
    headerTKey: 'bill.payment_reconcile.header.enter_payment_and_reconcile',
    modalBody: <MultipleSubjectsModalBody />,
    modalFooter: <MultipleSubjectsModalFooter />,
    withBackwardsNavigation: true,
  },
  {
    backwardsNavigationStateId: SubjectReconciliationModalStateId.BankLines,
    id: SubjectReconciliationModalStateId.ConnectBank,
    headerTKey: 'bankreconciliation.connect_bank.title',
    modalBody: <ReconciliationConnectBankBody uiSource={UiSource.PayAndReconInvoices} />,
    withBackwardsNavigation: true,
  },
  {
    backwardsNavigationStateId: SubjectReconciliationModalStateId.ConnectBank,
    id: SubjectReconciliationModalStateId.ImportCsv,
    headerTKey: 'bank.account.modal.header.create',
    modalBody: <EditManualBankAccountFormBody form={csvAccountForm} />,
    modalFooter: <EditManualBankAccountFormFooter form={csvAccountForm} />,
    withBackwardsNavigation: true,
  },
]
